import { MergeCheck } from 'src/types';
import { ForgeMergeCheckResult } from 'src/types/custom-merge-checks';

import { isForgeMergeCheckResult, isMergeCheckFailedOrError } from '../utils';

const isMergeCheckRunning = (
  mergeCheck: ForgeMergeCheckResult | MergeCheck
): boolean => {
  if (isForgeMergeCheckResult(mergeCheck)) {
    return mergeCheck.status === 'IN-PROGRESS';
  }
  return false;
};

const getMergeCheckName = (
  mergeCheck: ForgeMergeCheckResult | MergeCheck
): string => {
  if (isForgeMergeCheckResult(mergeCheck)) {
    return mergeCheck.check.name;
  }
  return mergeCheck.name;
};

export const mergeCheckResultComparator = (
  a: ForgeMergeCheckResult | MergeCheck,
  b: ForgeMergeCheckResult | MergeCheck
): number => {
  const isAFailedOrError = isMergeCheckFailedOrError(a);
  const isBFailedOrError = isMergeCheckFailedOrError(b);

  if (isAFailedOrError && !isBFailedOrError) {
    return -1;
  }
  if (!isAFailedOrError && isBFailedOrError) {
    return 1;
  }

  const isARunning = isMergeCheckRunning(a);
  const isBRunning = isMergeCheckRunning(b);
  if (isARunning && !isBRunning) {
    return -1;
  }
  if (!isARunning && isBRunning) {
    return 1;
  }

  const aName = getMergeCheckName(a);
  const bName = getMergeCheckName(b);
  return aName.localeCompare(bName);
};
